import * as React from "react";
const SvgCircleFilled = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8.5, r: 8, fill: "currentColor" }));
export default SvgCircleFilled;
